import axios from 'axios'
import { extractErrorMessage } from './utils'

const API_URL = process.env.NEXT_PUBLIC_API_URL

/**
 * Create an enrollment
 * @param {Object} payload - Enrollment payload
 * @param {string} payload.first_name - First name
 * @param {string} payload.last_name - Last name
 * @param {string} payload.account_address - Account address
 * @param {string} payload.email - Email address
 * @param {string} [payload.phone_number] - Phone number (optional)
 * @param {string} [payload.account_id] - Account ID (optional)
 * @param {string} [payload.auth0_id] - Auth0 user ID (optional)
 * @param {Object} [headers] - Optional headers (for authenticated requests)
 * @returns {Promise<void>}
 */
export async function createEnrollment(payload, headers = null) {
  try {
    const config = {
      method: 'post',
      url: `${API_URL}/enrollment`,
      data: payload,
    }

    if (headers) {
      config.headers = headers
    } else {
      config.headers = {
        'Content-Type': 'application/json',
      }
    }

    await axios(config)
  } catch (err) {
    const errorMessage = extractErrorMessage(
      err,
      'An error occurred while processing your enrollment. Please try again.'
    )
    throw new Error(errorMessage)
  }
}
